import { render } from "./EmergencyTriage.vue?vue&type=template&id=78aafa2e&ts=true"
import script from "./EmergencyTriage.ts?vue&type=script&lang=ts&external"
export * from "./EmergencyTriage.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__